import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import {
  Address,
  ApprovalFormItem,
  createAddress,
  IBankDetails,
  IBusinessData,
  IChargingCardContactPerson,
  IConfirmationStatus,
  IERechnungsInfo,
  IInvoiceConfig,
  IOlavEntry,
  IPersonalData,
  IProduktAuswahlDetails,
  IProduktSelektion,
  IVertragskonto,
  PreisIndikation,
  Product,
} from '@mwe/models';
import { withAuthenticationStateFeature } from '../../store-features/authentication.feature';
import { ServiceStateEnum } from '@mwe/constants';
import { withStorageServiceFeature } from '../../store-features/storage-service.feature';
import { ConfirmationStatusState, withConfirmationStatusState } from '../../store-features/confirmation-status-state.feature';
import { MemoryCacheItem } from '../../cache/memory-cache.service';
import { computed } from '@angular/core';

const initialState = {
  productSelection: undefined as IProduktSelektion,
  personalData: undefined as IPersonalData,
  businessData: undefined as IBusinessData,
  carModelType: undefined as string,
  numberOfCards: undefined as string,
  invoiceData: undefined as IVertragskonto,
  invoiceAddress: undefined as Address,
  invoiceAddressOlav: undefined as IOlavEntry,
  eRechnungsInfo: undefined as IERechnungsInfo,
  bankDetails: undefined as IBankDetails,
  orderDate: undefined as string,
  confirmationStatus: undefined as IConfirmationStatus,
  orderSuccessfull: undefined as boolean,
  grantedMarketingPermission: undefined as boolean,
  state: undefined as ServiceStateEnum,
  tariffSelectionState: undefined as ServiceStateEnum,
  products: undefined as IProduktAuswahlDetails[],
  initialProduct: undefined as IProduktSelektion,
  defaultTariff: undefined as string,
  preselectedTariffKey: undefined as string,
  contactPerson: undefined as IChargingCardContactPerson,
  useContactPerson: undefined as boolean,
  isERechnungSliderVisible: undefined as boolean,
  invoiceInfoConfig: undefined as IInvoiceConfig,
  isZahlscheinSelected: undefined as boolean,
  orderSummaryProducts: undefined as Product[],
  approvalItems: undefined as ApprovalFormItem[],
  selectedPriceIndications: undefined as PreisIndikation[],
};

type InitialChargingCardOrderState = typeof initialState;

export const ChargingCardOrderStore = signalStore(
  { providedIn: 'root' },
  withConfirmationStatusState({
    _memoryCacheItem: MemoryCacheItem.ClearingAccountDetails,
  }),
  withState(initialState),
  withAuthenticationStateFeature(),
  withStorageServiceFeature('charging-card-order', true),
  withMethods(store => {
    const updateStoreState = (storeStateValues: Partial<InitialChargingCardOrderState> & Partial<ConfirmationStatusState>) => {
      patchState(store, { ...storeStateValues });
    };

    return {
      updateStoreState,
    };
  }),
  withComputed(store => ({
    createdInvoiceAddress: computed(() => (store.invoiceAddress() && createAddress(store.invoiceAddress())) || undefined),
  })),
);
